export default {
    name: 'ContextCampaign',
    properties: {
        utm_source: {},
        utm_medium: {},
        utm_campaign: {},
        utm_term: {},
        utm_content: {},
    },
};
